import { DocumentIcon } from '@/assets/static/icons/document';
import { IAiAssets } from '@/components/aiAssistant/types';
import CheckBox from '@/components/basicComponents/checkbox';
import { EllipsisWithTooltip } from '@/components/basicComponents/ellipsisWithTooltip';
import ModalWrappedContent from '@/components/basicComponents/modal/modalWrappedContent';
import { themeVar } from '@/styles/theme';
import { Dispatch, SetStateAction } from 'react';
import styled from 'styled-components';

interface AiSuggestionsProps {
  isOpen: boolean;
  filesForAiAssistant: IAiAssets[];
  selectedFiles: string[];
  setSelectedFiles: Dispatch<SetStateAction<string[]>>;
  handleGenerateAnswers: () => void;
  onClose: () => void;
}

const AiSuggestions = ({ isOpen, filesForAiAssistant, selectedFiles, setSelectedFiles, handleGenerateAnswers, onClose }: AiSuggestionsProps) => {
  return (
    <ModalWrappedContent
      isOpen={isOpen}
      onClose={onClose}
      confirmButton={{
        name: 'Confirm',
        onClick: handleGenerateAnswers,
        disabled: !selectedFiles.length
      }}
    >
      <ModalContainer>
        <ModalTitel>Generate AI Suggestions</ModalTitel>
        <ModalContentWrap>
          <ModalDescription>
            The AI Assistant will suggest answers to the due diligence questions based on this deal's source material. View this deal on the Due
            Diligence Page to review the suggestions once the process is finished.
          </ModalDescription>
          <ModalDescription>Documents selected for AI Assistant:</ModalDescription>
          <UploadedDocumnts>
            {filesForAiAssistant.map((file) => (
              <CheckboxWrapper
                key={file.id ? file.id : file.filename}
                id={file.id ? file.id : file.filename}
                onClick={() => {
                  const updatedSelectedFiles = selectedFiles.includes(file.filename)
                    ? selectedFiles.filter((el) => el !== file.filename)
                    : [...selectedFiles, file.filename];
                  setSelectedFiles(updatedSelectedFiles);
                }}
              >
                <CheckBox id={file.filename} isActive={selectedFiles.includes(file.filename)} />
                <FileNameWrapper>
                  <DocumentIconWrapper>
                    <DocumentIcon />
                  </DocumentIconWrapper>
                  <EllipsisWithTooltip title={file.filename}>{file.filename}</EllipsisWithTooltip>
                </FileNameWrapper>
              </CheckboxWrapper>
            ))}
          </UploadedDocumnts>
        </ModalContentWrap>
      </ModalContainer>
    </ModalWrappedContent>
  );
};

export default AiSuggestions;

const ModalContainer = styled.div`
  font-weight: 400;
  padding: 50px 0;
`;

const ModalTitel = styled.div`
  font-size: 33px;
  text-align: center;
  color: ${themeVar('font.strong')};
`;

const ModalDescription = styled.div`
  font-size: 19px;
  line-height: 27px;
  text-align: center;
  color: ${themeVar('font.base')};
`;

const ModalContentWrap = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
`;

const UploadedDocumnts = styled.div`
  display: flex;
  flex-direction: column;
  gap: 15px;
  padding: 5px;
  max-height: 100px;
  overflow-y: auto;
`;

const FileNameWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
`;

const DocumentIconWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
`;

const CheckboxWrapper = styled.div`
  cursor: pointer;
  display: flex;
  gap: 9px;
  color: ${themeVar('font.base')};
  font-size: 16px;
  font-weight: 400;
  line-height: 22.4px;
  padding: 5px;
  margin-top: 5px;
`;
